export default __webpack_public_path__ + "static/media/loginLogo2.d52288a1.png";